import React, { memo } from 'react';
import Head from 'next/head';
import LandingLayout from '@/components/landing/home/LandingLayout';
import SEO from '@/components/landing/seo';
import CollegeAmbassador from '@/components/landing/ambassador';

const BecomeAmbassador = () => {
  return (
    <>
      <Head>
        <title>Become Ambassador | Learnsic</title>
        <link
          rel="canonical"
          href={`${process.env.NEXT_PUBLIC_SITE_URL}become-ambassador`}
        />
      </Head>
      <SEO
        meta_title={'Learnsic College Ambassador Program'}
        meta_description={'Learnsic College Ambassador Program'}
        meta_keywords={'Ambassador, Learnsic, College, School, Rewards, Learning'}
        photo={'https://s3.ap-south-1.amazonaws.com/learnsic.com/learnsic_cover.png'}
        canonical="become-ambassador"
      />
      <LandingLayout>
        <CollegeAmbassador />
      </LandingLayout>
    </>
  );
};

export default memo(BecomeAmbassador);
